import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const submitDocxForConversion = async (docxToHTML = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!docxToHTML) {
        console.log("no docxToHTML");
        return null;
    }
    console.log("CALLING SERVER with docxtojsonsectionsconverter")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'docxtojsonsectionsconverter',
            'apiToken': apiToken,
            'docxToHTML': docxToHTML
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from docxtojsonsectionsconverter call");
    }).catch((error) => { console.log(error); });
};

const addSectionsToCompositionResource = async (foiString = null, jsonSectionArray = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!foiString) {
        console.log("no foiString");
        return null;
    }
    if (!jsonSectionArray) {
        console.log("no jsonSectionArray");
        return null;
    }
    console.log("CALLING SERVER with addsectionstocomposition")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'addsectionstocomposition',
            'apiToken': apiToken,
            'resourceid': foiString,
            'jsonSectionArray': jsonSectionArray
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from addsectionstocomposition call");
    }).catch((error) => { console.log(error); });
};

export default submitDocxForConversion;
export { addSectionsToCompositionResource };